export const KEY_FLEXIBLE = 'org.coursera.ondemand.schedule.Flexible';
export const KEY_FLEXIBLE_CAMEL_CASE = 'orgCourseraOndemandScheduleFlexible';

export const KEY_STRICT = 'org.coursera.ondemand.schedule.Strict';
export const KEY_STRICT_CAMEL_CASE = 'orgCourseraOndemandScheduleStrict';
